    <app-radio-input [label]="otherApplicantsQuestionText" shortLabel="Other Applicants"
          [control]="otherApplicantsForm.controls.otherApplicants"
          [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
          [submitAttempted]="submitAttempted"
          >
    </app-radio-input>
@if(otherApplicantsForm.controls.otherApplicants.value === 'true') {

     <div class="section-label">
          <mat-label>{{ otherApplicantsTableText }}</mat-label>
    </div>
@if(safePersonList.length > 0) {

  @if(!(isMobile$ | async)) {
  <table mat-table [dataSource]="safePersonList" class="mat-elevation-z1">
      
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width: 28%;">Name</th>
        <td mat-cell *matCellDef="let person">{{person.firstName}} {{person.surname}}</td>
      </ng-container>

      <!-- DOB Column -->
      <ng-container matColumnDef="dob">
        <th mat-header-cell *matHeaderCellDef style="width: 14%;">DOB</th>
        <td mat-cell *matCellDef="let person">{{person.dob | date:'dd/MM/yyyy'}}</td>
      </ng-container>

      <!-- Passport Column -->
      <ng-container matColumnDef="passport">
        <th mat-header-cell *matHeaderCellDef style="width: 19%;">Passport</th>
        <td mat-cell *matCellDef="let person">{{person.passportNumber}}</td>
      </ng-container>

      <!-- Marital Status Column (hidden for VEVO) -->
      <ng-container matColumnDef="marital">
        <th mat-header-cell *matHeaderCellDef style="width: 19%;">Marital</th>
        <td mat-cell *matCellDef="let person">{{person.maritalStatus?.value}}</td>
      </ng-container>

      <!-- Edit Column -->
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef style="width: 5%;">Edit</th>
        <td mat-cell *matCellDef="let person; let i = index">
          <button mat-icon-button (click)="edit(i)" aria-label="Edit">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Delete Column -->
      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef style="width: 5%;">Delete</th>
        <td mat-cell *matCellDef="let person; let i = index">
          <button mat-icon-button (click)="remove(i)" aria-label="Delete" color="warn">
            <mat-icon>close</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  }
  @if(isMobile$ | async) {
          <div class="mobile-cards">
        @for(person of safePersonList; track person; let i = $index) {
        <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Name:</span>
                <span class="value">{{person.firstName}} {{person.surname}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">DOB:</span>
                <span class="value">{{person.dob | date:'dd/MM/yyyy'}}</span>
              </div>
              @if(person.passportNumber) {
              <div class="mobile-card-item">
                <span class="label">Passport:</span>
                <span class="value">{{person.passportNumber}}</span>
              </div>
              }
              @if(person.maritalStatus) {
              <div class="mobile-card-item" >
                <span class="label">Marital:</span>
                <span class="value">{{person.maritalStatus.value}}</span>
              </div>
            }
            </div>
            <div class="mobile-card-actions">
              <button mat-stroked-button (click)="edit(i)" class="action-button">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-stroked-button color="warn" (click)="remove(i)" class="action-button">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            </div>
          </mat-card-content>
        </mat-card>
  
      }
    </div>
  }

}
   <button mat-raised-button color="primary" (click)="add()">{{ AddButtonText }}</button>
}

